import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox"]
  static values = { max: Number }

  connect() {
    this.update();
  }

  update() {
    const checkedCount = this.checkboxTargets.filter(checkbox => checkbox.checked).length;
    this.checkboxTargets.forEach(checkbox => {
      checkbox.disabled = !checkbox.checked && checkedCount >= this.maxValue;
    });
  }
}
